<template>
  <div class="logo d-center">
    <div class="logo-content j-flex">
      <div class="logo-left">
        <img class="logo-logo" src="../../assets/img/schoolLogo-cy.svg" />
        <!-- <img class="logo-name" src="../../assets/img/School Logo name.svg" /> -->
      </div>
      <div class="logo-center">
        <!-- <div class="fs-xxl sys-name">体育教育教学系统管理平台</div>
        <div class="fs-sm sys-name-en">
          Physical Education and Sport Pedagogy System management platform
        </div> -->
        <img class="" src="../../assets/img/systemName.svg" />
      </div>
      <div class="logo-right">
        <div class="search j-flex">
          <input
            class="search-input"
            v-model="searchKey"
            @keyup.enter="globalSearch"
          />
          <button class="search-btn j-flex" @click="globalSearch">
            <img src="../../assets/img/search.svg" />搜索
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchKey: '',
    }
  },
  methods: {
    globalSearch() {
      if (this.searchKey != '') {
        this.$router.push({
          path: '/search',
          query: {
            search: this.searchKey,
            //   one: '搜索',
            //   two: '',
            //   three: '',
            //   path: '',
            //   keepalive: '',
            //   keepchild: this.listChildIndex,
            //   articleId: item.id,
          },
        })
        this.searchKey = ''
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../../assets/css/main.scss';
.logo {
  height: 122px;
  width: 100%;
  min-width: 1100px;
  background-color: $mainGreen;
}
.logo-content {
  width: 1100px;
}
.logo-name {
  margin-left: 16px;
}
.logo-left {
  //   width: 380px;
  width: 290px;
}
.logo-center {
  color: $white;
  margin-top: -8px;
  width: 432px;
}
.sys-name {
  font-family: fantasy;
}
.sys-name-en {
  font-size: 12.7px;
}
.logo-right {
  width: 247px;
}
.sys-name-en {
  margin-top: 4px;
}
.search-input {
  width: 184px;
  height: 30px;
  background: linear-gradient(317.29deg, #e6f2ed 86.71%, #ffb612 98.24%);
  box-shadow: inset 0px 1px 1px rgba(0, 0, 0, 0.25);
  border: none;
  outline: none;
  text-indent: 8px;
}
.search-btn {
  width: 63px;
  height: 32px;
  background: linear-gradient(317.37deg, #007a4d 47.02%, #ffb612 100%);
  border: none;
  color: $white;
  cursor: pointer;
  outline: none;
}
</style>
